module.exports = __webpack_public_path__ + "static/img/ic_launcher.6ad072b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wxcode/ic_launcher.png
// module id = Q8Up
// module chunks = 1